import PaginationDTO from "@/DTO/paginationDTO"

export default class PaginationModel {
  constructor(item) {
    Object.assign(this, new PaginationDTO(item))
  }

  get totalPages() {
    return Math.ceil(this.count / this.size)
  }

  get isLastPage() {
    if(this.page === this.totalPages) return true
    return false
  }

  loadMore() {
    this.page++;
  }
}